module.exports = __webpack_public_path__ + "media/images/views/home/benefit/benefit-3-dbcfec86003251d96e60eca27217d852.png";